import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'; 
import './Header.css';
import logo from '../assets/logo.png';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false); // Cierra el menú cuando se hace clic en un enlace
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeMenu);
    return () => {
      document.removeEventListener('mousedown', closeMenu);
    };
  }, []);

  return (
    <header className="header">
      <div className="header-container">
      <Link to="/">
        <div className="header-logo">
            <img src={logo} alt="Logo MBZ" />
          </div>
      </Link>
        <button className="menu-toggle" onClick={toggleMenu}>
          <i className="fas fa-bars"></i>
        </button>
        <nav ref={menuRef} className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
          <Link to="/" title="Inicio" onClick={handleLinkClick}>
            <i className="fa fa-home"></i> Inicio
          </Link>
          <Link to="/metodologia" title="Metodología" onClick={handleLinkClick}>
            <i className="fa fa-book"></i> Metodología
          </Link>
          <Link to="/equipo" title="Equipo" onClick={handleLinkClick}>
            <i className="fa fa-users"></i> Equipo
          </Link>
          <Link to="/services" title="Servicios" onClick={handleLinkClick}>
            <i className="fa fa-child"></i> Servicios
          </Link>
          <Link to="/tienda" title="Tienda" onClick={handleLinkClick}>
            <i className="fa fa-shopping-cart"></i> Tienda
          </Link>
          <Link to="/contact" title="Contacto" onClick={handleLinkClick}>
            <i className="fas fa-envelope"></i> Contacto
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
